
export const Colors = {
	"LightBlue":"#11b8f8",
	"SammyBlue":"#5b7ffa",
	"SammyPurple":"#875bfa",
	"SammyMint":"#5bcefa",
	"SammyRed":"#fa5b7f",
	"SammyYellow":"#fad65b"
}

export const ColorsB = {
	"B00":"#008eff",
	"B01": "#7492fb",
	"B02": "#fbdd74",
	"B03": "#7cbefa",
	"B04": "#3c3731",
	//"B05": "#455460"
	"B05":"#055581",
	"B06":"#b9ddff"
}

export const MagicPalette = {
	StrongBlue		: "#1d55b1ff",
	MisteryPurple	: "#e755b1ff",
	SoftBlue		: "#7cbefa",
}

export const ZSC = {
	"Gray"		: "#A3AAB2FF",
	"LightGray"	: "#EAF4FFFF",
	"Orange"	: "#FFA300FF",
	"Orange2"	: "#FA777B",
	"Lisa"		: "#3399FFFF",
	"DeepBlue"	: "#003057FF",
	"SoftBlue"	: "#7cbefa",
	"Mint"		: "#1FBFC3FF",
	"SynthPurple": "#8F65EB",
	"DeepSynthPurple":"#3F2449",
	"SynthPurple2":"#6A3D7B",
	"SynthPurple3":"#5B356A",
	"Black02"	: "#272725"
}

export const Sammy = {
	"Iron"		: "#08232F",
	"Blue"		: "#28AFEF",
	"Lisa"		: "#3399FF",
	"SoftLisa"	: "#99ccff",
	"IronLisa"	: "#0A1E33",
	"Livie"		: "#968AD0",
	"LisaOrange": "#FF9933",
	"Magenta"	: "#FF3399",
	
}

export const SammyLight = {
	Blue		: "#3399ff",
	Livie		: "#c882f1",
	Magenta		: "#ff69b6",
	Orange		: "#ff7766",
	Oragne2		: "#ffa600",
	Gray		: "#F8F8F8",
}

// # #8DE7FD
// #fda38d
